import React, { useState } from 'react'
import AutoScroll from './AutoScroll'
import Pagination from './Pagination'
import { FaChevronRight, FaChevronLeft, FaCog } from 'react-icons/fa';
import AudioEditionSelector from './AudioEditionSelector';
import FontSwitcher from './FontSwitcher';

export default function Controls({ ayahs, playMode, setPlayMode, startAyah, setStartAyah, endAyah, setEndAyah, coloringModes, setColoringModes, selectedEdition, setSelectedEdition, showAll, hideAll, hideRandomWords, hideRandomVerses, currentPage, togglePlayAll, isPlayingAll, repeatAll, setRepeatAll, repeatVerse, setRepeatVerse, addSilence, setAddSilence, changePage, changePaginationType, paginationType, setCurrentFont, setCurrentPage, totalPages, displayStartAyah, setDisplayStartAyah, displayEndAyah, setDisplayEndAyah, metaData, autoPaginate, setAutoPaginate, displayMode, setDisplayMode, currentFavoriteId, setCurrentFavoriteId, loadFavoriteById, setIsSearchOpen, fontSizeFactor, setFontSizeFactor, textOpacity, setTextOpacity, isPaused, togglePause }) {
    const [isOpen, setIsOpen] = useState(false);
    const [hideMode, setHideMode] = useState('words');
    const [hideDifficulty, setHideDifficulty] = useState(0.5);

    const toggleSidebar = () => setIsOpen(!isOpen);

    const handlePrint = () => {
        window.print();
    };

    return (
        <>
            <button className="sidebar-toggle" onClick={toggleSidebar}>
                {isOpen ? <FaChevronLeft /> : <FaCog />}
            </button>
            <div className={`settings-sidebar ${isOpen ? 'open' : 'closed'}`}>
                {/* Search Button */}
                <div style={{ position: 'absolute', top: '15px', left: '15px', display: 'flex', gap: '5px' }}>
                    <button
                        onClick={handlePrint}
                        style={{ background: '#f8f9fa', border: '1px solid #ddd', borderRadius: '4px', padding: '5px 10px', cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '5px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}
                        title="طباعة"
                    >
                        🖨️ طباعة
                    </button>
                    <button
                        onClick={() => setIsSearchOpen(true)}
                        style={{ background: '#f8f9fa', border: '1px solid #ddd', borderRadius: '4px', padding: '5px 10px', cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '5px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}
                        title="البحث في القرآن"
                    >
                        🔍 بحث
                    </button>
                </div>
                {/* Toggle Button */}

                <div className="settings-content" style={{ marginTop: '20px' }}>
                    <Pagination
                        changePage={changePage}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        onFontChange={setCurrentFont}
                        paginationType={paginationType}
                        setPaginationType={changePaginationType}
                        displayStartAyah={displayStartAyah}
                        setDisplayStartAyah={setDisplayStartAyah}
                        displayEndAyah={displayEndAyah}
                        setDisplayEndAyah={setDisplayEndAyah}
                        ayahsCount={paginationType === 'surah' ? ayahs.length : 0}
                        metaData={metaData}
                        displayMode={displayMode}
                        setDisplayMode={setDisplayMode}
                        currentFavoriteId={currentFavoriteId}
                        setCurrentFavoriteId={setCurrentFavoriteId}
                        loadFavoriteById={loadFavoriteById}
                    />



                    <div className="settings">
                        <div className='settingSectionTitle'>
                            <h4>استماع وتحفيظ </h4>
                        </div>

                        <div className="surah-name" style={{ display: 'flex', gap: '5px', alignItems: 'center', justifyContent: 'center' }}>
                            <AudioEditionSelector 
                                togglePlayAll={togglePlayAll} 
                                isPlayingAll={isPlayingAll} 
                                selectedEdition={selectedEdition} 
                                setSelectedEdition={setSelectedEdition} 
                                isPaused={isPaused} 
                                togglePause={togglePause} 
                            />
                        </div>
                        {paginationType !== 'surah' && (
                            <div className="form-group">
                                <label>وضع التشغيل: </label>
                                <select
                                    id="playMode"
                                    value={playMode}
                                    onChange={(e) => setPlayMode(e.target.value)}
                                >
                                    <option value="all">كل الآيات</option>
                                    <option value="range">نطاق معين</option>
                                </select>
                            </div>
                        )}

                        {paginationType !== 'surah' && playMode === 'range' && (
                            <div className="form-group range-selector">
                                <div>
                                    <label>من آية: </label>
                                    <select
                                        id="startAyah"
                                        value={startAyah || ''}
                                        onChange={(e) => {
                                            const value = parseInt(e.target.value);
                                            setStartAyah(value);
                                            // Ensure endAyah is not less than startAyah
                                            if (endAyah && value > endAyah) {
                                                setEndAyah(value);
                                            }
                                        }}
                                    >
                                        {ayahs.map((ayah) => (
                                            <option key={`start-${ayah.numberInSurah}`} value={ayah.numberInSurah}>
                                                {ayah.numberInSurah}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label>إلى آية: </label>
                                    <select
                                        id="endAyah"
                                        value={endAyah || ''}
                                        onChange={(e) => {
                                            const value = parseInt(e.target.value);
                                            // Ensure endAyah is not less than startAyah
                                            if (startAyah && value >= startAyah) {
                                                setEndAyah(value);
                                            } else {
                                                setEndAyah(startAyah);
                                            }
                                        }}
                                    >
                                        {ayahs.map((ayah) => (
                                            <option key={`end-${ayah.numberInSurah}`} value={ayah.numberInSurah}>
                                                {ayah.numberInSurah}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}
                        <div className='form-group'>
                            <label>تكرار الكل: </label>
                            <select
                                id="repeatAll"
                                value={repeatAll}
                                onChange={(e) => setRepeatAll(parseInt(e.target.value))}
                            >
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(num => (
                                    <option key={`all-${num}`} value={num}>{num}</option>
                                ))}
                            </select>
                        </div>
                        <div className='form-group'>

                            <label>تكرار كل آية: </label>
                            <select
                                id="repeatVerse"
                                value={repeatVerse}
                                onChange={(e) => setRepeatVerse(parseInt(e.target.value))}
                            >
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(num => (
                                    <option key={`verse-${num}`} value={num}>{num}</option>
                                ))}
                            </select>
                        </div>
                        <div className='form-group'>

                            <label htmlFor='addSilence'>إضافة صمت: </label>
                            <input
                                type="checkbox"
                                id="addSilence"
                                checked={addSilence}
                                onChange={(e) => setAddSilence(e.target.checked)}
                            />
                        </div>
                        <div className='form-group'>
                            <label htmlFor='autoPaginate'>متابعة التلاوة تلقائياً: </label>
                            <input
                                type="checkbox"
                                id="autoPaginate"
                                checked={autoPaginate}
                                onChange={(e) => setAutoPaginate(e.target.checked)}
                            />
                        </div>
                    </div>

                    <div className='settingSectionTitle'>
                        <h4>اختبار الحفظ </h4>
                    </div>
                    <div className="settings" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '10px' }}>
                        <div style={{ display: 'flex', gap: '5px' }}>
                            <button onClick={showAll} style={{ flex: 1 }}>إظهار الكل</button>
                            <button onClick={hideAll} style={{ flex: 1 }}>إخفاء الكل</button>
                        </div>
                        <div className="form-group" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <label>نوع الاختبار:</label>
                            <select value={hideMode} onChange={(e) => setHideMode(e.target.value)}>
                                <option value="words">إخفاء كلمات عشوائية</option>
                                <option value="verses">إخفاء آيات عشوائية</option>
                            </select>
                        </div>
                        <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                            <label style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span>مستوى الإخفاء (الصعوبة):</span>
                                <span>{Math.round(hideDifficulty * 100)}%</span>
                            </label>
                            <input
                                type="range"
                                min="0.1"
                                max="0.9"
                                step="0.1"
                                value={hideDifficulty}
                                onChange={(e) => setHideDifficulty(parseFloat(e.target.value))}
                                style={{ width: '100%' }}
                            />
                        </div>
                        <button
                            onClick={() => hideMode === 'verses' ? hideRandomVerses(hideDifficulty) : hideRandomWords(hideDifficulty)}
                            style={{ background: '#2b7a78', color: 'white', border: 'none', padding: '10px', borderRadius: '5px', cursor: 'pointer', fontSize: '1.25rem' }}
                        >
                            تطبيق الاختبار العشوائي
                        </button>
                    </div>

                    <div className='settingSectionTitle'>
                        <h4 style={{ margin: '15px 0 5px', width: '100%', textAlign: 'right' }}>التلوين والمظهر</h4>
                    </div>
                    <div className="settings" style={{ flexDirection: 'column', alignItems: 'stretch', gap: '10px' }}>
                        <FontSwitcher onFontChange={setCurrentFont} />

                        <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                            <label htmlFor="size-factor" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span>الحجم:</span>
                                <span>{Math.round(fontSizeFactor * 100)}%</span>
                            </label>
                            <input
                                type="range"
                                id="size-factor"
                                min="0.5"
                                max="3"
                                step="0.1"
                                value={fontSizeFactor}
                                onChange={(e) => setFontSizeFactor(parseFloat(e.target.value))}
                                style={{ width: '100%' }}
                            />
                        </div>
                        <div className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                            <label htmlFor="text-opacity" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span>الشفافية:</span>
                                <span>{Math.round(textOpacity * 100)}%</span>
                            </label>
                            <input
                                type="range"
                                id="text-opacity"
                                min="0.1"
                                max="1"
                                step="0.1"
                                value={textOpacity}
                                onChange={(e) => setTextOpacity(parseFloat(e.target.value))}
                                style={{ width: '100%' }}
                            />
                        </div>
                        <div className='form-group' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <label htmlFor='coloringModes'>تلوين: </label>
                            <select
                                id="coloringModes"
                                value={coloringModes}
                                onChange={(e) => setColoringModes(e.target.value)}
                            >
                                <option value="">لا</option>
                                <option value="endingPatterns">المتشابهات </option>
                                <option value="firstWordColoring">أول كلمة من كل آية  </option>
                                <option value="firstUniqueWordSetColoring">أول كلمات فريدة من كل آية </option>
                            </select>
                        </div>
                    </div>



                    {!isPlayingAll && <AutoScroll />}

                </div>
            </div>
        </>


    )
}
